import React, { Component } from "react";
import {Card, Form, Button, Row, Col} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import AsyncSelect from 'react-select/async';
import { FaEdit, FaCheck } from "react-icons/fa";
import '../ProgramasV2/ProgramasEdit.module.css';

class FarmacovigilanciaPrograma extends Component {
    constructor(props) {
        super(props);
        this.state = {
            programa_id: this.props.programa_id,
            dadosFarmacovigilancia: this.props.dadosFarmacovigilancia,
            erroLoadRegistro: '',
            loading: false,
            page_numb: this.props.page_numb || 1,
            page_limit: this.props.page_limit || 10
        }
    }

    componentDidMount() {
        this.carregarDadosFarmacovigilanciaPrograma();
    }

    carregarDadosFarmacovigilanciaPrograma = async () => {
        const { programa_id } = this.state;
    
        if (programa_id) {

            this.setState({
                loading: true,
                erroLoadRegistro: ''
            });
    
           
            api.get(`/programas/farmacovigilancia/?programa_id=${programa_id}`)
                .then(response => {
                    const dadosFarmacovigilancia = response.data.results;
    
                    if (dadosFarmacovigilancia.length > 0) {
                        const registro = dadosFarmacovigilancia[0];
                        
                        this.setState({
                            dadosFarmacovigilancia: {
                                ...this.state.dadosFarmacovigilancia,
                                texto_sessao1: registro.texto_sessao1 || '',
                                n_documento: registro.n_documento || '',
                                versao: registro.versao || '',
                            },
                            loading: false
                        });
                    } else {
                        this.setState({
                            dadosFarmacovigilancia: {
                                ...this.state.dadosFarmacovigilancia,
                                texto_sessao1: '',
                                n_documento: '',
                                versao: '',
                            },
                            loading: false
                        });
                    }
                })
                .catch(error => {
                    console.error("Erro ao consultar dados de farmacovigilância:", error);
                    let erro_msg = 'Erro ao consultar dados de farmacovigilância, tente novamente';
                    if (error.response && error.response.status === 500) {
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }
                    this.setState({
                        erroLoadRegistro: erro_msg,
                        loading: false
                    });
                });
        } else {
            this.setState({
                dadosFarmacovigilancia: {
                    ...this.state.dadosFarmacovigilancia,
                    texto_sessao1: '',
                    n_documento: '',
                    versao: '',
                },
                erroLoadRegistro: '',
                loading: false
            });
        }
    };

    enviarFarmacovigilancia = async (e) => {
        e.preventDefault();
        const formDataPrograma = new FormData();
        const formDataFarmacovigilancia = new FormData();
    
        formDataPrograma.append('farmacovigilancia_formulario_id', this.state.dadosFarmacovigilancia.farmacovigilancia_formulario_id);
        formDataPrograma.append('farmacovigilancia_formulario_nome', this.state.dadosFarmacovigilancia.farmacovigilancia_formulario_nome);
        formDataPrograma.append('farmacovigilancia_email', this.state.dadosFarmacovigilancia.farmacovigilancia_email);

        const urlPrograma = this.state.programa_id ? `/programas/${this.state.programa_id}/` : '/programas/';
        const metodoPrograma = this.state.programa_id ? 'put' : 'post';
    
        await api({
            method: metodoPrograma,
            url: urlPrograma,
            data: formDataPrograma,
        })
        .then(responsePrograma => {
            // Chamada para verificar se já existe um registro de farmacovigilância
            const urlCheckFarmacovigilancia = `/programas/farmacovigilancia/?programa_id=${this.state.programa_id}`;
    
            api.get(urlCheckFarmacovigilancia)
            .then(responseCheck => {
                // Se houver um registro, atualiza; caso contrário, cria um novo
                const existeRegistro = responseCheck.data.length > 0;
                const farmacovigilanciaId = existeRegistro ? responseCheck.data[0].id : null;
    
                const urlFarmacovigilancia = existeRegistro
                    ? `/programas/farmacovigilancia/${farmacovigilanciaId}/`
                    : `/programas/farmacovigilancia/`;
                const metodoFarmacovigilancia = existeRegistro ? 'put' : 'post';
    
                formDataFarmacovigilancia.append('texto_sessao1', this.state.dadosFarmacovigilancia.texto_sessao1);
                formDataFarmacovigilancia.append('n_documento', this.state.dadosFarmacovigilancia.n_documento);
                formDataFarmacovigilancia.append('versao', this.state.dadosFarmacovigilancia.versao);
                formDataFarmacovigilancia.append('programa_id', this.state.programa_id);

                api({
                    method: metodoFarmacovigilancia,
                    url: urlFarmacovigilancia,
                    data: formDataFarmacovigilancia,
                })
                .then(responseFarmacovigilancia => {
                    const MySwal = withReactContent(Swal);
                    const textSwal = existeRegistro
                        ? 'Farmacovigilância atualizada com sucesso'
                        : 'Farmacovigilância cadastrada com sucesso';
    
                    MySwal.fire({
                        title: <p>{textSwal}</p>,
                        icon: 'success',
                        showCloseButton: true,
                    });
    
                    this.setState({
                        loading: false,
                        farmacovigilancia_id: responseFarmacovigilancia.data.id,
                    });

                    this.carregarDadosFarmacovigilanciaPrograma();
                })
                .catch(error => {
                    this.handleError(error, 'Erro ao salvar os campos de farmacovigilância');
                });
            })
            .catch(error => {
                this.handleError(error, 'Erro ao verificar registro de farmacovigilância');
            });
        })
        .catch(error => {
            this.handleError(error, 'Erro ao salvar o formulário e o email');
        });
    };

    onChangeFarmacovigilancia = (farmacovigilanciaSelecionado) => {
        this.setState({ farmacovigilancia_formulario_id: farmacovigilanciaSelecionado ? farmacovigilanciaSelecionado.value : '', farmacovigilancia_formulario_nome: farmacovigilanciaSelecionado ? farmacovigilanciaSelecionado.label : ''  });
    };

    carregarFormulariosFarmacovigilancia = async (inputValue) => {
        if(!this.state.focusFormularioFarmacovigilancia) {
            return [];
        }
        try {
            const response = await api.get(`/formularios/?status=1&nome=${inputValue}`);
            const opcoes = response.data.results.map(farmacovigilancia_formulario => ({
                value: farmacovigilancia_formulario.id,
                label: farmacovigilancia_formulario.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar formulários de farmacovigilância:', error);
            return [];
        }
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ dadosFarmacovigilancia: { ...this.state.dadosFarmacovigilancia, [name]: value } });
    };

    render() {
        return (
            <>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <Form onSubmit={this.enviarFarmacovigilancia}>
                            <h4>Farmacovigilância</h4>
                            <Row>
                                <Col sm={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Formulário de Farmacovigilância</Form.Label>
                                        <AsyncSelect
                                            key={this.state.focusFormularioFarmacovigilancia}
                                            loadOptions={(inputValue) => {
                                                return new Promise((resolve) => {
                                                    clearTimeout(this.formularioFarmacovigilanciaSearchTimeout);
                                                    this.formularioFarmacovigilanciaSearchTimeout = setTimeout(() => {
                                                        resolve(this.carregarFormulariosFarmacovigilancia(inputValue));
                                                    }, 700);
                                                });
                                            }}
                                            onFocus={() => {
                                                this.setState({
                                                    focusFormularioFarmacovigilancia: true
                                                });
                                            }}
                                            autoFocus={this.state.focusFormularioFarmacovigilancia}
                                            openMenuOnFocus={this.state.focusFormularioFarmacovigilancia}
                                            defaultOptions
                                            name="farmacovigilancia_formulario_id"
                                            placeholder="Buscar formulário..."
                                            noOptionsMessage={() => "Nenhum formulário encontrado"}
                                            onChange={this.onChangeFarmacovigilancia}
                                            value={this.state.dadosFarmacovigilancia.farmacovigilancia_formulario_id ? { value: this.state.dadosFarmacovigilancia.farmacovigilancia_formulario_id, label: this.state.dadosFarmacovigilancia.farmacovigilancia_formulario_nome} : null}

                                            />
                                    </Form.Group>
                                </Col>
                                <Col sm={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Email para Envio de Relatório</Form.Label>
                                        <Form.Control
                                            type="email"
                                            name="farmacovigilancia_email"
                                            placeholder="Informe o email"
                                            value={this.state.dadosFarmacovigilancia.farmacovigilancia_email}
                                            onChange={this.handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Texto PDF</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            name="texto_sessao1"
                                            rows={3}
                                            placeholder="Informe o texto do PDF"
                                            value={this.state.dadosFarmacovigilancia.texto_sessao1}
                                            onChange={this.handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Número do Documento</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="n_documento"
                                            placeholder="Informe o número do documento"
                                            value={this.state.dadosFarmacovigilancia.n_documento}
                                            onChange={this.handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Versão</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="versao"
                                            placeholder="Informe a versão"
                                            value={this.state.dadosFarmacovigilancia.versao}
                                            onChange={this.handleChange}
                                        />
                                    </Form.Group>
                                </Col>                                                                                                                                                                 
                            </Row>
                            <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                {this.state.loading ? (
                                    <span className="spinner-border spinner-border-sm"></span>
                                ) : (
                                    <>
                                        <FaCheck className="me-1" /> Salvar
                                    </>
                                )}
                            </Button>
                        </Form> 
                    </Card.Body>                
                </Card>
            </>
        );
    }
}

export default FarmacovigilanciaPrograma;

